module.exports = __webpack_public_path__ + "img/2.fbbfea63.jpeg";